import {useSelector} from "react-redux";
import {useEffect} from "react";
import {useAppDispatch} from "./index";
import {checkCandidateContactDetailsGeneratedStatus} from "store/project/GenerateContactDetails/generateCandidateContactDetailsAsyncActions";
import {generateCandidatesContactDetailsForAllProjectSelector} from "store/project/GenerateContactDetails/generateCandidateContactDetailsSelectors";
import {TRootState} from "types";

/* eslint-disable  @typescript-eslint/no-explicit-any */
let candidateIdsIntervalId = {} as any;
const useCandidateContactDetailsInstantDisplay = () => {
	const dispatch = useAppDispatch();

	let allCandidateIdsInProgress = useSelector((state: TRootState) =>
		generateCandidatesContactDetailsForAllProjectSelector(state),
	);
	allCandidateIdsInProgress = Object.values(allCandidateIdsInProgress).flat();

	/**
	 * Here on the state we have kept the information for all candidate contact details generate request by project
	 * Then We watch the candidate ids for the project and send a request to check if the contact details is generated
	 * if generated then we remove the specific id from the watch list and update the info on the candidate list
	 */

	useEffect(() => {
		if (
			allCandidateIdsInProgress &&
			Array.isArray(allCandidateIdsInProgress) &&
			allCandidateIdsInProgress?.length > 0
		) {
			candidateIdsIntervalId = setInterval(async () => {
				await dispatch(
					checkCandidateContactDetailsGeneratedStatus(allCandidateIdsInProgress),
				);
			}, 5 * 1000);

			setTimeout(() => {
				clearInterval(candidateIdsIntervalId);
			}, 60 * 30 * 1000); // it will clear after 30 min
		}

		if (allCandidateIdsInProgress?.length === 0) {
			clearInterval(candidateIdsIntervalId);
		}

		return () => {
			if (candidateIdsIntervalId) {
				clearInterval(candidateIdsIntervalId);
			}
		};
	}, [allCandidateIdsInProgress, dispatch]);
};

export default useCandidateContactDetailsInstantDisplay;
